/**
 * TypeBox schemas for the hexastore Edge entity.
 *
 * All relationships between nodes (Route, Plan, Activity, Feature,
 * LayerGroup, User) are stored as edges in a single table.
 */

import { Type, type Static } from 'typebox'
import { UUID, ISODate, type Exact } from './common.js'

export const PredicateSchema = Type.Union([
  Type.Literal('has-feature'),
  Type.Literal('has-layer-group'),
  Type.Literal('has-child'),
  Type.Literal('follows-route'),
  Type.Literal('linked-to-plan'),
  Type.Literal('has-activity'),
  Type.Literal('derived-from'),
  Type.Literal('has-member'),
  Type.Literal('has-field-log-entry'),
  Type.Literal('favorited'),
])
export type Predicate = Static<typeof PredicateSchema>

/**
 * Node reference string: "type:uuid" (e.g. "route:abc-123", "user:def-456")
 */
export const NodeRef = Type.String({ minLength: 3 })
export type NodeRef = Static<typeof NodeRef>

export const EdgeSchema = Type.Object({
  id: UUID,
  subject: NodeRef,
  predicate: PredicateSchema,
  object: NodeRef,
  properties: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
  version: Type.Number({ minimum: 0 }),
  createdAt: ISODate,
})
export type Edge = Exact<Static<typeof EdgeSchema>>

/** Fields required when creating an edge */
export const EdgeCreateSchema = Type.Object({
  subject: NodeRef,
  predicate: PredicateSchema,
  object: NodeRef,
  properties: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
})
export type EdgeCreate = Static<typeof EdgeCreateSchema>
